import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-hotpatch",
  "use": "app-icon-hotpatch-usage",
  "viewBox": "0 0 60 74",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 60 74\" id=\"app-icon-hotpatch\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M-10-3h80v80h-80z\" /><path d=\"M41.735 70v4h-26v-4h26zm0-8v4h-26v-4h26zm-12-62l29.474 32.326a1 1 0 01-.74 1.674H41.736v24h-26V34H1a1 1 0 01-.739-1.674L29.735 0zm0 5.936L7.794 30h11.941v24h18V30h13.94L29.735 5.936z\" fill=\"#BACCFF\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol